<template>
	<Page :theme="'gray'" animate>
		<template v-slot:content>
			<div class="top">
				<SafeAreaTop theme="light" @close="onClose"> </SafeAreaTop>
				<img src="@/assets/post/workbooks_special.png" alt="" />
			</div>

			<div class="container">
				<div class="title">
					Our exclusive workbooks, full of professional advice on how to move and eat, for a healthier you
				</div>

				<div class="workbooks">
					<div class="workbook">
						<div class="workbook-row">
							<div class="workbook--image right">
								<img src="@/assets/post/nutrition/en.png" alt="" />
							</div>
							<div class="workbook-info">
								<div class="workbook--title left">Healthy Eating Workbook</div>
								<div class="workbook--description">Our exclusive workbooks, designed with your goals in mind</div>
							</div>
						</div>
					</div>
					<div class="workbook">
						<div class="workbook-row">
							<div class="workbook--image">
								<img src="@/assets/post/workout/en.png" alt="" />
							</div>
							<div class="workbook-info">
								<div class="workbook--title">Your Workout Workbook</div>
								<div class="workbook--description">
									Learn how physical activity can be a part of your daily routine. We’ll teach you how to move, breathe
									and flow, and be more active
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id="form" class="products-label">Discount available for Premium Members only</div>

				<Products :products="products" :active="activeProduct" @select="handleSelect" theme="centered" />
			</div>

			<modal :isOpen="showDownloadModal">
				<template v-slot:body>
					<DownloadModal @close="onCloseDownloadModal" :user_id="userId" />
				</template>
			</modal>
		</template>

		<template v-slot:footer>
			<div class="container">
				<p-button
					v-scroll-to="{ el: '#form', offset: -20, onDone: onScrollDone }"
					label=""
					:loading="isLoading"
					cls="btn btn-primary btn-block"
				>
					GET WORKBOOKs
				</p-button>
			</div>
		</template>
	</Page>
</template>

<script>
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import Page from '@/components/Page'
import Products from '@/components/products/ios/Products'
import Modal from '@/components/Modal'
import PButton from '@/components/Button'
import DownloadModal from '@/components/DownloadModal'

import { computed, ref } from '@vue/reactivity'
import { inject, onMounted } from '@vue/runtime-core'

import useApi from '@/composition/api.js'
import useEnv from '@/composition/env.js'
import { useStore } from 'vuex'

export default {
	components: {
		Page,
		Products,
		Modal,
		DownloadModal,
		SafeAreaTop,
		PButton
	},

	setup() {
		const BUNDLE_WORKBOOK_PRODUCT_ID = 'simple_down_all_workbooks'

		const api = useApi()
		const store = useStore()
		const env = useEnv()
		const appboy = inject('appboy')
		const amplitude = inject('amplitude')

		let products = computed(() =>
			store.getters['products/getData']([
				{
					id: BUNDLE_WORKBOOK_PRODUCT_ID,
					text: 'Workbook bunddle',
					old: {
						id: 'simple_original_subscription_12_months_trial'
					},
					subtitle: '[price] [old_price]'
				}
			])
		)

		let activeProduct = ref(products.value[0])

		const handleSelect = (product) => {
			activeProduct.value = product
		}

		/** Loading */
		let isLoading = computed(() => store.state.isLoading)

		/** Email */
		let hasEmail = computed(() => Boolean(store.state.user.email))

		/** Download Modal */
		let showDownloadModal = ref(false)

		let userId = computed(() => store.state.user.user_id)

		const close = (Status = 'Close', product = {}) => {
			amplitude.logEvent('Post Paywall - Close', {
				Layout: 'Offer 92% off',
				From: store.getters['getSource'],
				Step: 'Workbooks',
				Status
			})

			amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallDone'), {
				action: Status.toLowerCase(),
				product_type: 'workbook',
				...product
			})

			api.close()
		}
		const onClose = () => close()
		const onCloseDownloadModal = () => {
			close('Purchase', {
				product_id: activeProduct.value.id,
				price: Math.abs(activeProduct.value.product_price),
				currency: activeProduct.value.currency
			})
		}

		/** Purchase */
		const purchase = async () => {
			api.purchase({
				productId: activeProduct.value.id,
				onFinish: async () => {
					if (hasEmail) {
						const options = {
							external_id: userId.value,
							has_workout_workbook: true,
							has_nutrition_workbook: true
						}

						await appboy.userTrack([options])
						await appboy.canvas(env('BRAZE_WORKBOOKS_CANVAS_ID'), userId.value)
					}

					amplitude.logEvent('Paywall - Done', {
						Layout: 'Offer 92% off',
						From: store.getters['getSource'],
						Step: 'Workbooks',
						ProductId: activeProduct.value.id,
						Status: 'Purchase'
					})

					showDownloadModal.value = true
				},
				onError: (product, text) => {
					console.log(product, text)
				},
				onCancel: () => {},
				closeOnSuccess: false
			})
		}

		/** Scroll */
		const onScrollDone = async () => {
			purchase()
		}

		onMounted(() => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallShow'), {
				product_ids: products.value.map((product) => product.id),
				product_type: 'workbook',
				prices: products.value.map((product) => product.product_price),
				currency: activeProduct.value.currency
			})
		})

		return {
			products,
			activeProduct,
			handleSelect,
			purchase,
			showDownloadModal,
			onScrollDone,
			isLoading,
			onClose,
			onCloseDownloadModal,
			userId
		}
	}
}
</script>

<style lang="scss" scoped>
.top {
	height: 30vh;
	background-color: #7d8bf7;
	position: relative;

	img {
		position: absolute;
		top: 4.3vh;
		left: 50%;
		transform: translateX(-55%);
		height: 31.5vh;

		@media (max-height: 750px) {
			height: 33.5vh;
		}
	}
}

.subtitle {
	margin-top: 5.5rem;
	text-align: center;
	font-size: 1.2rem;

	@media (min-width: 768px) {
		margin-top: 6.5rem;
	}

	@media (min-width: 991px) {
		margin-top: 8.5rem;
	}
}

.title {
	font-size: 1.6rem;
	line-height: 1.3;
	font-weight: 900;
	text-align: center;
	text-transform: uppercase;
	margin-bottom: 2rem;
	margin-top: 5.5rem;
	color: #3b3c57;

	@media (min-width: 768px) {
		margin-top: 6.5rem;
	}

	@media (min-width: 991px) {
		margin-top: 8.5rem;
	}
}

.form-group {
	margin-bottom: 15px;

	&--label {
		margin-bottom: 0.5rem;
		display: block;
		font-weight: 500;
		text-transform: uppercase;
	}

	&--note {
		font-size: 0.8rem;
		margin-top: 0.5rem;
		padding-left: 0.5rem;
	}
}

.form-control {
	display: block;
	width: 100%;
	padding: 1rem 1.3rem;
	font-size: 1.1275rem;
	font-weight: 400;
	line-height: 1.3;
	color: #212529;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #fff;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.6rem;
	transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out;

	&:focus {
		color: #212529;
		background-color: #fff;
		border-color: #86b7fe;
		outline: 0;
	}

	&:disabled {
		border-color: #bfbfbf;
		color: #4a4a4a;
		background-color: transparent;
		opacity: 1;
	}

	&.error {
		border-color: red;
	}
}

.workbooks {
	margin-top: 2rem;
}

.workbook {
	margin-bottom: 2rem;

	&:last-child {
		margin-bottom: 0;
	}

	&-row {
		display: flex;
	}

	&--image {
		width: 25%;
	}

	&-info {
		width: 75%;
		padding-left: 1.5rem;
	}

	&--title {
		font-size: 1.5rem;
		font-weight: 500;
		line-height: 1.2;
		margin-bottom: 1rem;
	}

	&--description {
		font-size: 1rem;
		margin-top: 1rem;
	}
}

.left {
	text-align: left;
}

.right {
	text-align: right;
}

.products-label {
	margin-top: 2rem;
	margin-bottom: -1.2rem;
	font-size: 0.96rem;
	text-align: center;
	color: #3b3c57;
}
</style>
